import styles from './styles.module.scss';
import { useEffect, useState } from 'react';
import { Icons } from 'pages/Profile/components/icons';
import { hexToRgba } from 'utils';
import FormattedPhone from 'components/FormattedPhone';
import classNames from 'classnames';

const ContactCard = ({ contactPhones, contactEmail }) => {
  const [displayPhoneNumber, setDisplayPhoneNumber] = useState<string | null>(null);

  useEffect(() => {
    if (contactPhones?.length) {
      let phoneNumber = '';
      phoneNumber = contactPhones.find((phone) => phone.IsPrimary)?.PhoneNumber;

      if (!phoneNumber) phoneNumber = contactPhones[0].PhoneNumber;

      setDisplayPhoneNumber(phoneNumber);
    }
  }, [contactPhones?.length]);

  return (
    <div className={styles.contactCard}>
      {displayPhoneNumber && (
        <div className={styles.section}>
          <div
            className={styles.left}
            style={{
              backgroundColor: hexToRgba('#4673D1', 0.08),
            }}
          >
            <Icons variant={Icons.PHONE} />
          </div>
          <div className={styles.right}>
            <div className={styles.heading}>Text Notifications</div>
            <div className={styles.text}>Notifications will be sent to</div>
            <FormattedPhone className={styles.info}>{displayPhoneNumber}</FormattedPhone>
          </div>
        </div>
      )}
      <div className={classNames(styles.section, { [styles.sectionMargin]: !!displayPhoneNumber })}>
        <div
          className={styles.left}
          style={{
            backgroundColor: hexToRgba('#FB913A', 0.08),
          }}
        >
          <Icons variant={Icons.EMAIL} />
        </div>
        <div className={styles.right}>
          <div className={styles.heading}>Email Notifications</div>
          <div className={styles.text}>Notifications will be sent to</div>
          <div className={styles.info}>{contactEmail}</div>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
